//
//
//
//
//
//
//
//
//
//

// noinspection JSUnusedGlobalSymbols
export default {
  name: 'InviteButton',
  methods: {
    clicked () {
      this.$emit('click')
    }
  }
}
